import { RefObject, useEffect } from 'react'

const useScrollLoading = (
  scrollElem: RefObject<HTMLDivElement | null>,
  eventCallback: () => void,
  dependencies: Array<any>
): void => {
  useEffect(() => {
    const scrollEventCallback = () => {
      if (!scrollElem.current) return
      const position = scrollElem.current.getBoundingClientRect()
      if (position.bottom - screen.height < 400) {
        eventCallback()
      }
    }

    window.addEventListener('scroll', scrollEventCallback)

    return () => {
      window.removeEventListener('scroll', scrollEventCallback)
    }
  }, [...dependencies])
}

export default useScrollLoading
